import Config from '@app/models/Config';

export default {
  apiHost: import.meta.env.VITE_API_HOST,
  apiV2Host: import.meta.env.VITE_API_V2_HOST,
  cdnHost: import.meta.env.VITE_CDN_HOST,
} satisfies Config;
